import styled from 'styled-components';

export const StyledHeader = styled.div`
	width: 100%;
`;
